"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavbarEndSection;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/actions/index.js"));
var _index2 = _interopRequireDefault(require("../../animation/motion-move/index.js"));
// ============================================================================
// STYLED COMPONENTS
// ============================================================================

const TrailingSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrailingSection",
  class: "pl-t18bvvoe"
});
const ContentElement = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ContentElement",
  class: "pl-cc8o21y"
});
const CaptionText = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "CaptionText",
  class: "pl-co7ldsw"
});
const PriceText = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "PriceText",
  class: "pl-pp4wpxf"
});
const ContentAndActionsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentAndActionsContainer",
  class: "pl-c1ix3wx4"
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-c160bbxu"
});

// ============================================================================
// MAIN COMPONENT
// ============================================================================

/**
 * Navbar End Section Component
 * Contains CTA buttons and supporting content (price/disclaimer) at the end of the navbar
 * @param {Object} props - Component props
 * @returns {React.ReactElement} Navbar End Section Component
 */
function NavbarEndSection({
  partial,
  cta,
  hasIntersectedObserved,
  isMobile,
  disclaimer,
  priceQualifier,
  unitPrice
}) {
  return /*#__PURE__*/_react.default.createElement(TrailingSection, {
    className: "navbar-end-section",
    "data-cy": "trailing-section",
    "data-partial": partial
  }, cta && (hasIntersectedObserved || isMobile) && /*#__PURE__*/_react.default.createElement(_index2.default, {
    mode: "swift",
    variant: "appear",
    intensity: "300",
    triggerOnce: true
  }, /*#__PURE__*/_react.default.createElement(ContentAndActionsContainer, {
    className: "navbar-end-section__container",
    "data-cy": "content-and-actions-container"
  }, disclaimer && /*#__PURE__*/_react.default.createElement(ContentElement, {
    className: "navbar-end-section__disclaimer",
    "data-cy": "disclaimer"
  }, /*#__PURE__*/_react.default.createElement(CaptionText, {
    "data-variant": "disclaimer"
  }, disclaimer)), !disclaimer && priceQualifier && unitPrice && /*#__PURE__*/_react.default.createElement(ContentElement, {
    className: "navbar-end-section__price-lockup",
    "data-cy": "price-lockup"
  }, /*#__PURE__*/_react.default.createElement(CaptionText, null, priceQualifier), /*#__PURE__*/_react.default.createElement(PriceText, null, unitPrice)), /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      size: 'small'
    }]
  })))));
}
NavbarEndSection.propTypes = {
  partial: _propTypes.default.string,
  cta: _propTypes.default.object,
  hasIntersectedObserved: _propTypes.default.bool.isRequired,
  isMobile: _propTypes.default.bool.isRequired,
  disclaimer: _propTypes.default.string,
  priceQualifier: _propTypes.default.string,
  unitPrice: _propTypes.default.string
};